document.addEventListener('DOMContentLoaded', () => {
  const popup = document.querySelector('[data-login-popup]');
  if (!popup) return;

  window.loginPopup = popup;

  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-open-login]');
    if (!btn) return;

    popup.showModal();
  });
});
